// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

var $$Array = require("rescript/lib/js/array.js");
var Curry = require("rescript/lib/js/curry.js");
var Belt_List = require("rescript/lib/js/belt_List.js");
var Js_string = require("rescript/lib/js/js_string.js");
var Belt_Array = require("rescript/lib/js/belt_Array.js");
var JsxRuntime = require("react/jsx-runtime");
var MultiSelectDropDown$ReactHooksTemplate = require("../common/MultiSelectDropDown.res.js");
var ImportEnrichmentCondition$ReactHooksTemplate = require("./ImportEnrichmentCondition.res.js");
var ImportEnrichmentRuleTypes$ReactHooksTemplate = require("./ImportEnrichmentRuleTypes.res.js");
var ImportEnrichmentPatternCatalog$ReactHooksTemplate = require("./ImportEnrichmentPatternCatalog.res.js");

function ImportEnrichmentConditionForm(props) {
  var onFormatChange = props.onFormatChange;
  var onValueChange = props.onValueChange;
  var onOperatorChange = props.onOperatorChange;
  var labelBase = props.labelBase;
  var selectBase = props.selectBase;
  var inputBase = props.inputBase;
  var fieldOptions = props.fieldOptions;
  var row = props.row;
  var fieldKind = ImportEnrichmentCondition$ReactHooksTemplate.fieldKindForPath(row.path, fieldOptions);
  var operators = ImportEnrichmentCondition$ReactHooksTemplate.availableOperators(fieldKind);
  var valueInput = ImportEnrichmentCondition$ReactHooksTemplate.valueInputFor(fieldKind, row.op, fieldOptions);
  var renderValueInput = function (param) {
    if (typeof valueInput !== "object") {
      switch (valueInput) {
        case "NoValue" :
            return null;
        case "TextInput" :
            return JsxRuntime.jsxs("div", {
                        children: [
                          JsxRuntime.jsx("label", {
                                children: "Value",
                                className: labelBase
                              }),
                          JsxRuntime.jsx("input", {
                                className: inputBase,
                                placeholder: ImportEnrichmentCondition$ReactHooksTemplate.valuePlaceholder(fieldKind, row.op),
                                value: row.value,
                                onChange: (function (e) {
                                    Curry._1(onValueChange, e.target.value);
                                  })
                              })
                        ]
                      });
        case "NumberInput" :
            return JsxRuntime.jsxs("div", {
                        children: [
                          JsxRuntime.jsx("label", {
                                children: "Value",
                                className: labelBase
                              }),
                          JsxRuntime.jsx("input", {
                                className: inputBase,
                                placeholder: ImportEnrichmentCondition$ReactHooksTemplate.valuePlaceholder(fieldKind, row.op),
                                type: "number",
                                value: row.value,
                                onChange: (function (e) {
                                    Curry._1(onValueChange, e.target.value);
                                  })
                              })
                        ]
                      });
        case "DateInput" :
            return JsxRuntime.jsxs("div", {
                        children: [
                          JsxRuntime.jsx("label", {
                                children: "Value",
                                className: labelBase
                              }),
                          JsxRuntime.jsx("input", {
                                className: inputBase,
                                type: "date",
                                value: row.value,
                                onChange: (function (e) {
                                    Curry._1(onValueChange, e.target.value);
                                  })
                              })
                        ]
                      });
        case "FormatPreset" :
            return JsxRuntime.jsxs("div", {
                        children: [
                          JsxRuntime.jsx("label", {
                                children: "Format preset",
                                className: labelBase
                              }),
                          JsxRuntime.jsx("select", {
                                children: $$Array.of_list(Belt_List.map(ImportEnrichmentPatternCatalog$ReactHooksTemplate.formatKeys, (function (key) {
                                            return JsxRuntime.jsx("option", {
                                                        children: ImportEnrichmentPatternCatalog$ReactHooksTemplate.formatLabel(key),
                                                        value: key
                                                      }, key);
                                          }))),
                                className: selectBase + " sm:max-w-md",
                                value: row.format,
                                onChange: (function (e) {
                                    Curry._1(onFormatChange, e.target.value);
                                  })
                              })
                        ]
                      });
        
      }
    } else {
      if (valueInput.TAG === "SingleSelect") {
        var tmp;
        var exit = 0;
        if (typeof fieldKind !== "object" && fieldKind === "ContextCampaignUid") {
          tmp = JsxRuntime.jsxs("select", {
                children: [
                  JsxRuntime.jsx("option", {
                        children: "Choose a campaign",
                        value: ""
                      }),
                  Belt_Array.map(fieldOptions.campaignUidOptions, (function (option) {
                          return JsxRuntime.jsx("option", {
                                      children: option.label,
                                      value: option.value
                                    }, option.value);
                        }))
                ],
                className: selectBase,
                value: row.value,
                onChange: (function (e) {
                    Curry._1(onValueChange, e.target.value);
                  })
              });
        } else {
          exit = 1;
        }
        if (exit === 1) {
          tmp = JsxRuntime.jsxs("select", {
                children: [
                  JsxRuntime.jsx("option", {
                        children: "Choose a value",
                        value: ""
                      }),
                  $$Array.of_list(Belt_List.map(valueInput._0, (function (option) {
                              return JsxRuntime.jsx("option", {
                                          children: option,
                                          value: option
                                        }, option);
                            })))
                ],
                className: selectBase,
                value: row.value,
                onChange: (function (e) {
                    Curry._1(onValueChange, e.target.value);
                  })
              });
        }
        return JsxRuntime.jsxs("div", {
                    children: [
                      JsxRuntime.jsx("label", {
                            children: "Value",
                            className: labelBase
                          }),
                      tmp
                    ]
                  });
      }
      var options = valueInput._0;
      return JsxRuntime.jsxs("div", {
                  children: [
                    JsxRuntime.jsx("label", {
                          children: "Values",
                          className: labelBase
                        }),
                    Belt_List.length(options) > 0 ? JsxRuntime.jsx(MultiSelectDropDown$ReactHooksTemplate.make, {
                            defaultPlaceholder: "Select values",
                            options: options,
                            selectedOptions: Belt_List.fromArray(Belt_Array.keep(Belt_Array.map(Js_string.split(row.value, ","), (function (v) {
                                            return v.trim();
                                          })), (function (v) {
                                        return v !== "";
                                      }))),
                            handleChange: (function (selected) {
                                Curry._1(onValueChange, Belt_List.toArray(selected).join(", "));
                              }),
                            width: "w-full"
                          }) : JsxRuntime.jsx("input", {
                            className: inputBase,
                            placeholder: ImportEnrichmentCondition$ReactHooksTemplate.valuePlaceholder(fieldKind, row.op),
                            value: row.value,
                            onChange: (function (e) {
                                Curry._1(onValueChange, e.target.value);
                              })
                          }),
                    JsxRuntime.jsx("p", {
                          children: Belt_List.length(options) > 0 ? "Select one or more values." : "Enter comma-separated values.",
                          className: "text-xs text-gray-500 mt-1"
                        })
                  ]
                });
    }
  };
  var match = row.op;
  var tmp = match === "regex_match" ? JsxRuntime.jsx("span", {
          children: ImportEnrichmentRuleTypes$ReactHooksTemplate.opLabel("regex_match"),
          className: "inline-flex items-center border border-orangeamber bg-lemonchifon text-charcoal rounded-lg px-4 py-2 text-sm w-full"
        }) : JsxRuntime.jsx("select", {
          children: $$Array.of_list(Belt_List.map(operators, (function (op) {
                      return JsxRuntime.jsx("option", {
                                  children: ImportEnrichmentRuleTypes$ReactHooksTemplate.opLabel(op),
                                  value: op
                                }, op);
                    }))),
          className: selectBase,
          value: ImportEnrichmentCondition$ReactHooksTemplate.isOperatorValid(row.op, fieldKind) ? row.op : ImportEnrichmentCondition$ReactHooksTemplate.defaultOperator(fieldKind),
          onChange: (function (e) {
              Curry._1(onOperatorChange, e.target.value);
            })
        });
  var match$1 = row.op;
  var tmp$1 = match$1 === "regex_match" ? JsxRuntime.jsxs("div", {
          children: [
            JsxRuntime.jsx("p", {
                  children: "Legacy regex condition. Remove and re-add using contains, does not contain, or matches format to change the operator.",
                  className: "text-xs text-amber-800"
                }),
            JsxRuntime.jsx("div", {
                  children: row.pattern,
                  className: "text-sm font-mono text-gray-800 bg-white border border-gray-200 rounded-lg p-2 break-all"
                }),
            JsxRuntime.jsx("p", {
                  children: row.caseSensitive ? "Case sensitive" : "Case insensitive",
                  className: "text-xs text-gray-600"
                })
          ],
          className: "mt-2 pt-2 border-t border-amber-100 bg-amber-50 rounded-lg p-3 space-y-2"
        }) : JsxRuntime.jsx("div", {
          children: renderValueInput(),
          className: "mt-3"
        });
  return JsxRuntime.jsxs(JsxRuntime.Fragment, {
              children: [
                JsxRuntime.jsxs("div", {
                      children: [
                        JsxRuntime.jsx("label", {
                              children: "Operator",
                              className: labelBase
                            }),
                        tmp
                      ]
                    }),
                tmp$1
              ]
            });
}

var make = ImportEnrichmentConditionForm;

exports.make = make;
/* react/jsx-runtime Not a pure module */
